import { IApplicationState } from '../../types/redux';
import { selectDeviceType } from './selectDeviceType';

export const selectIsDesktop = (state: IApplicationState) => {
  const deviceType = selectDeviceType(state);

  return deviceType === 'desktop';
};
